import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import CommentCircleIcon from '../../../../assets/notification-bubble-icon.svg';

const CreateResponseNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={CommentCircleIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> created a new </span>
          <span className="font-extrabold text-growth-green">response</span>
          <span> to your </span>
          <span className="font-extrabold text-growth-green">article</span>
        </p>
        {meta.requestTitle && (
          <p className="text-sm font-bold text-growth-green-900 mt-1">
            &ldquo;{meta.requestTitle}&rdquo;
          </p>
        )}
        {meta.responseTitle && (
          <p className="text-sm text-gray-600 mb-2">on "{meta.responseTitle}"</p>
        )}
      </div>
    </div>
  );
};

export default CreateResponseNotification;
